import { useDispatch } from "react-redux";

import { setSelectedShapefile } from "store/features";

import {
  FlexItem,
  LayerActionsWrapper,
  LeafTitle,
  ProjectLinkedShapefileActions,
  ProjectLinkedShapefileColorPicker
} from "../../../../shared";
import { useRightClickContextMenu } from "../../../../shared/hooks/useRightClickContextMenu";

interface IMcDanielShapefileNode {
  node;
  canSelectItems?: boolean;
}

export function McDanielShapefileNode({ node, canSelectItems }: IMcDanielShapefileNode) {
  const dispatch = useDispatch();
  const { openContextMenu, contextMenuObject, nodeRef } = useRightClickContextMenu();

  return (
    <LeafTitle
      ref={nodeRef}
      onContextMenu={openContextMenu}
      data-testid="mcdaniel-shapefile-container">
      <FlexItem>
        <ProjectLinkedShapefileColorPicker
          projectShapefileId={node.projectShapefileId}
          shapefileId={node.shapefileId}
          color={node.layer.style.color}
          strokeColor={node.layer.style.strokeColor}
          thickness={node.layer.style.thickness}
          opacity={node.layer.style.opacity}
          disabled={true}
        />
        <label data-testid="mcdaniel-shapefile-title">{node.title}</label>
      </FlexItem>
      <FlexItem>
        <LayerActionsWrapper>
          <ProjectLinkedShapefileActions
            canExportShapefile={true}
            projectShapefileId={node.projectShapefileId}
            viewShapefileDetails={() => dispatch(setSelectedShapefile(node))}
            contextMenu={contextMenuObject}
            fileName={node.title}
            hasSelectItemsAction={canSelectItems}
          />
        </LayerActionsWrapper>
      </FlexItem>
    </LeafTitle>
  );
}
